<template>
  <div>
    <div class="text-right">
      <base-button @click="doRefresh" type="warning" size="md" class="btn-fill text-right">
        GENERATE TABLE
      </base-button>
    </div>
  </div>
</template>

<script>
  import {ReportsService} from '@/services';

  export default {
    data() {
      return {}
    },
    methods: {
      async doRefresh() {
        let vm = this;

        let loader = vm.$loading.show();

        await ReportsService.generateReports();

        window.location.reload();
        loader.hide();

      }
    }
  }
</script>